
import Vue from 'vue';
import Component from 'vue-class-component';
import NodeFormMixin from '../forms/NodeFormMixin';

@Component({
  name: 'ZoneSummary',
})
export default class ZoneSummary extends NodeFormMixin { }
